var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.switchLang},_vm._l((_vm.languages),function(lang){
var _obj;
return _c('button',{key:lang,class:[_vm.$style.btnLang, ( _obj = {}, _obj[_vm.$style.btnActive] = _vm.isActive(lang), _obj )],on:{"click":function($event){return _vm.switchLang(lang)}}},[_vm._v(" "+_vm._s(lang)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }